import { render, staticRenderFns } from "./Movement.vue?vue&type=template&id=b0e4dd0a&scoped=true&"
import script from "./Movement.vue?vue&type=script&lang=js&"
export * from "./Movement.vue?vue&type=script&lang=js&"
import style0 from "./Movement.vue?vue&type=style&index=0&id=b0e4dd0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e4dd0a",
  null
  
)

export default component.exports